(function() { window.GUID_f2e65dab_4b31_4961_900c_e774fc9eae96 = { getGuid: function() { return "f2e65dab-4b31-4961-900c-e774fc9eae96"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let PersonaDropdownPickerFormat;
        (function (PersonaDropdownPickerFormat) {
            PersonaDropdownPickerFormat[PersonaDropdownPickerFormat["Large"] = 0] = "Large";
            PersonaDropdownPickerFormat[PersonaDropdownPickerFormat["Small"] = 1] = "Small";
            PersonaDropdownPickerFormat[PersonaDropdownPickerFormat["PageHeader"] = 2] = "PageHeader";
        })(PersonaDropdownPickerFormat = Enumeration.PersonaDropdownPickerFormat || (Enumeration.PersonaDropdownPickerFormat = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=PersonaDropdownPickerFormat.pre.js.map
